<style>
    .ly-header .el-dropdown {
        float: right;
        color: #fff;
        margin: 15px 20px 0 0;    
        text-shadow: 0 1px 0 rgba(0,0,0,.3);
    }
    .ly-header .ly-logo {
        float: left;
        margin-left: 5px;
    }
    .ly-duty {
        float: right;
        margin-left: 15px;
    }
    .ly-header--dropdown {
        max-height: 95%;
        overflow-y: auto;
    }
    .ly-header .logo_text{
        font-size:16px;
        font-weight:bold;
        color:#fff;
        height:50px;
        line-height: 50px;
        display: flex;

    }
    .ly-header .logo_text img{
        margin-right:5px;
    }
</style>
<template>
    <div class="ly-header">
        <div v-if="other_domain" class="ly-logo logo_text">
            <img src="../../../assets/img/logo2.png" alt="" class="ly-logo-img"> 找胎后台管理系统
        </div>
        <div v-else class="ly-logo">
            <img src="../../../assets/img/logo.png" alt="" class="ly-logo-img">
        </div>
        <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
               你好，{{userInfo.name}}&nbsp;&nbsp;({{userInfo.company_name}})<i class="el-icon-caret-bottom el-icon--right"></i>
            </span>
            <el-dropdown-menu slot='dropdown' class="ly-header--dropdown">
                <template v-for="(el, i) in userInfo.role_list">
                    <el-dropdown-item :key="'me'+i" :command="el.employee_id">
                        {{el.company_name}}({{el.department_name}}) 
                        <span class="ly-duty">{{el.duty}}</span>
                    </el-dropdown-item>
                </template>
                <!-- <el-dropdown-item>{{userInfo.gangwei_name||'无'}}</el-dropdown-item>
                <el-dropdown-item>{{userInfo.department_name}}</el-dropdown-item>
                <el-dropdown-item>{{userInfo.company_name}}</el-dropdown-item> -->
                <!-- <el-dropdown-item divided>帮助</el-dropdown-item> -->
                <el-dropdown-item command="loginOut" divided>退出</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    export default {
        name: 'LyHeader',
        computed: {
            ...mapGetters([
                'userInfo'     
            ])
        },
        data () {
            return {
                other_domain: null
            }
        },
        mounted () {
            // 找胎后台
            this.other_domain = window.other_domain || false
        },
        methods: {
            handleCommand (command) {
                if (command === 'loginOut') {
                    this.$utils.loginOut()
                } else if (command) {
                    this.toggleEmployee(command)
                }
            },
            /**
             * 切换角色账号
             */
            toggleEmployee (id) {
                let loading = this.$loading({
                    lock: true,
                    text: '账号切换中...',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                })
                window.localStorage.removeItem('khqjyw_standard') // 清楚缓存数据
                window.localStorage.removeItem('khqjyw_extend') // 清楚缓存数据
                this.$api.create('api/account', {id: id}).then(() => {
                    location.reload()
                }).catch((err) => {
                    loading.close()
                    this.$message({
                        message: err,
                        type: 'warning'
                    })
                })
            }
        }
    }
</script>